import script from "./Dialogs.vue?vue&type=script&setup=true&lang=js"
export * from "./Dialogs.vue?vue&type=script&setup=true&lang=js"

import "./Dialogs.vue?vue&type=style&index=0&id=c58ca35a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c58ca35a"]])

export default __exports__